var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6246 3.72239C1.99431 3.01796 1.67917 2.66574 1.66728 2.3664C1.65696 2.10636 1.7687 1.85643 1.96938 1.69074C2.20039 1.5 2.67301 1.5 3.61825 1.5H15.9874C16.9326 1.5 17.4052 1.5 17.6362 1.69074C17.8369 1.85643 17.9487 2.10636 17.9383 2.3664C17.9264 2.66574 17.6113 3.01796 16.981 3.72239L12.2258 9.03703C12.1002 9.17745 12.0374 9.24766 11.9926 9.32756C11.9528 9.39843 11.9237 9.47473 11.906 9.55403C11.8861 9.64345 11.8861 9.73766 11.8861 9.92609V14.382C11.8861 14.5449 11.8861 14.6264 11.8599 14.6969C11.8366 14.7591 11.7989 14.8149 11.7497 14.8596C11.694 14.9102 11.6184 14.9404 11.4671 15.001L8.63374 16.1343C8.32745 16.2568 8.17431 16.3181 8.05137 16.2925C7.94386 16.2702 7.84952 16.2063 7.78885 16.1148C7.71947 16.0101 7.71947 15.8452 7.71947 15.5153V9.92609C7.71947 9.73766 7.71947 9.64345 7.69958 9.55403C7.68193 9.47473 7.65278 9.39843 7.61305 9.32756C7.56826 9.24766 7.50544 9.17745 7.3798 9.03703L2.6246 3.72239Z",
    stroke: "#B8C5CC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.a3a4d5da062c0d8a5e3f9c1723b33a7a.svg";
export { ForwardRef as ReactComponent };